import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { authAction } from "hooks/actions/mainAction";
import styled from "styled-components";
import { Avatar, Modal } from "antd";
import { UserOutlined, LoginOutlined } from "@ant-design/icons";
import StyledModal from "antComponents/Modal";
import getMenuInfo from "../../controllers/getMenuInfo";
import getUserInfo from "controllers/getUserInfo";
import { breadCrumbListAction, menuAction } from "hooks/actions/etcAction";

const StyledDiv = styled.div`
  flex: 0 0 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px;
  gap: 10px;

  position: relative;
  width: 100%;

  background: #006d75;
  /* drop-shadow/0.15 */

  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
`;

const StyledDiv1 = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: absolute; */
  width: 100px;
  height: 36px;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  /* identical to box height, or 157% */

  color: #ffffff;
  /* Neutral/1 */

  border: 1px solid #ffffff;
  border-radius: 5px;
`;

function GlobalHeader({ children }) {
  const dispatch = useDispatch();
  const backend = process.env.REACT_APP_BACKEND;
  const navigate = useNavigate();
  const authState = useSelector((state) => state.mainReducer.authState);
  const userInfo = useSelector((state) => state.mainReducer.userInfo);

  function logoutHandler() {
    StyledModal.confirm(
      "로그아웃",
      "로그아웃 하시겠습니까?",
      logoutOk,
      null,
      "로그아웃",
      "취소"
    );
  }

  function logoutOk() {
    axios
      .get(`${backend}/logout/logout`)
      .then((data) => {
        dispatch(authAction(false, null));
        dispatch(menuAction([],[]))
        dispatch(breadCrumbListAction([]))
      })
      .catch((err) => {
        if(err.response.status===401) {
          navigate("/auth")
        }
        console.log(err);
      });
  }

  const viewPicture = (_) => {
    Modal.info({
      content: (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
          <img src={`https://englemining-admin.s3.ap-northeast-2.amazonaws.com/${userInfo.thumbnail}`} style={{width:"100%"}}/>
        </div>
      ),
      icon: null,
      maskClosable: true,
      okButtonProps: {style: {display: 'none'}},
      bodyStyle: {padding:0},
      style: {padding: 0},
      className: "picture_modal",
    })
  }

  useEffect(() => {
    if (authState !== true) {
      navigate("/login");
    }
  }, [authState, navigate]);

  return (
    <StyledDiv>
      <StyledDiv1>잉글마이닝</StyledDiv1>
      {children}
      <div
        style={{
          display: "flex",
          width: "150px",
          justifyContent: "space-between",
        }}
      >
        {!userInfo || userInfo.thumbnail === null ? (
          <Avatar icon={<UserOutlined />} />
        ) : (
          <Avatar src={`https://englemining-admin.s3.ap-northeast-2.amazonaws.com/${userInfo.thumbnail}`} onClick={viewPicture}/>
        )}
        <div style={{ display: "flex", alignItems: "center", color: "white" }}>
          {userInfo ? userInfo.name : null}
        </div>
        <LoginOutlined
          style={{ color: "white", fontSize: "30px" }}
          onClick={logoutHandler}
        />
      </div>
    </StyledDiv>
  );
}

export default GlobalHeader;
